// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_f3-0";
export var fileCarousel = "_f3-2";
export var removeFileButton = "_f3-1";